export const sources={avif:"__VITE_ASSET__$aSNJRxZ__ 20w"};export const img={src:"__VITE_ASSET__BDCsavqB__",w:20,h:20};export default{sources:sources,img:img};